<template>
  <div>
    <b-button 
      v-if="$store.getters.userRole =='installer' || $store.getters.userRole =='collab'" @click="openNewMonitoringZone" >
      <span style="font-size:40px; font-weight: bold">+</span><br/>{{this.$t("zone.add_zone")}}
    </b-button>


    <!-- Crea nuova Monitoring Zone Modal-->
    <b-modal
      ref="modal"
      size="lg"
      :id="'modal-new-zone'+this._uid"
      :saveSubmit="saveSubmit"
      :title="$t('monitoring_zone.modal_title')"
      :ok-title="$t('user_modal.button_save')"
      :cancel-title="$t('user_modal.button_cancel')"
      @ok="handleOk"
    >
      <b-row>
      <b-col cols="9">
        
        <!--input name of zone -->
        <b-form-group class="ml-2">
          <label class="typo-label">{{$t("monitoring_zone.label_zone_name")}}</label>
          <b-form-input
            v-model="zoneName"
            type="text"
            :state="validation_zoneName"
          ></b-form-input>
          <b-form-invalid-feedback
            :state="validation_zoneName"
          >{{$t("signup.validation_null")}}</b-form-invalid-feedback>
         </b-form-group>

        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { uuid } from 'vue-uuid'; 


export default {
  name: "AddMonitoringZone",
  data() {
    return {
     zoneName: "",
     saveSubmit: "false",
    };
  },
props: {
    plant: {
      default: null
    }
  },
  computed: {
    ...mapState(['loading','error','commandsPending','commandResponse']),
    validation_zoneName() {
      if (this.saveSubmit == true) return this.zoneName.length > 0;
    }
  },
  mounted() {
        console.log("addMonitoringZone mounted");
        
  },
  methods: {
    openNewMonitoringZone() {
      this.zoneName = "";
      this.$bvModal.show('modal-new-zone' + this._uid);
      console.log("plant: ", this.plant);
    }, 
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.saveSubmit = true;
      // Trigger submit handler
      this.saveZone();
    },
    saveZone() {     
      if (!this.validation_zoneName) return; 
   
      this.$store.dispatch("createMonitoringZone", {
            plantId: this.$store.state.currentPlant.id,
            zoneId: "" + uuid.v1(),
            zoneName: this.zoneName,
            lamps:[]
      });

      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });
      
    }
  },

  watch: {
        loading(val) {
            console.log("zone loading changed:" + val+", error=" + this.error)
        },
        commandResponse(val) {
          console.log("updated commandResponse:",val);
          if (val.command == 'createMonitoringZone' && val.pending == false && val.error.data == '') 
            {
              console.log("monitoring zone created", val);
              this.$store.dispatch('loadPlantMonitoringZones', this.plant.id);  
            } 
        }
    },
};
</script>
